import React, {Component} from "react";

export class FutureDayBar extends Component {
    render() {
        return (
            <div className="graphic-item"/>
        )
    }
}